import * as mutation from "./mutation-types";
import * as systemLogMutation from "@/store/system-logs/mutation-types";
import * as action from "./action-types";
import { tableHelper } from "@/helpers/table.helper";
import axios from "axios";
import { deepCopyAxiosException } from "@/store/helpers";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";

export const actions = {
  async [action.LIST]({ commit, state }) {
    commit(mutation.LIST_STARTED);
    try {
      const url = tableHelper.constructUrl(`/api/providers/${state.listing.providerId}/contacts`, state.listing.paging);
      const { headers, data } = await axios.get(url);
      commit(mutation.LIST_SET_PAGING, tableHelper.getPagingFromHeaders(headers));
      commit(mutation.LIST_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.LIST_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.GET]({ commit, state }, { contactId }) {
    commit(mutation.GET_STARTED);
    try {
      const url = `/api/providers/${state.listing.providerId}/contacts/${contactId}`;
      const { data } = await axios.get(url);
      commit(mutation.GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.GET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.SET_STATUS_SAVE]({ commit, state }, { contactId, type, newStatus }) {
    commit(mutation.SET_STATUS_STARTED, { contactId, type, newStatus });
    try {
      const url = `/api/providers/${state.listing.providerId}/contacts/${contactId}/${type}-status`;
      const { data } = await axios.put(url, { status: newStatus });
      commit(mutation.SET_STATUS_SUCCEEDED, data);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(mutation.STATE_UNLOAD);
      return true;
    } catch (e) {
      commit(mutation.SET_STATUS_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.FLAG_AS_PRIMARY]({ commit, state }, { contactId, type, newPrimaryFlagValue }) {
    commit(mutation.FLAG_AS_PRIMARY_STARTED, { contactId, type, newPrimaryFlagValue });
    try {
      const url = `/api/providers/${state.listing.providerId}/contacts/${contactId}/${type}-promote-primary`;
      const { data } = await axios.put(url, {
        promoteAsPrimaryContact: newPrimaryFlagValue != null ? newPrimaryFlagValue : null
      });
      commit(mutation.FLAG_AS_PRIMARY_SUCCEEDED, data);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(mutation.STATE_UNLOAD);
      return true;
    } catch (e) {
      commit(mutation.FLAG_AS_PRIMARY_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  }
};
